import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-940352f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "chartDetailModal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "detailChart" }, null, -1))

import { ref } from "vue";
import API from "@/api";
import * as echarts from "echarts";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartDetailModal',
  setup(__props, { expose: __expose }) {

const chartData = ref<API.ChartVO>({});
const visible = ref(false);

const openModal = (data: API.ChartVO) => {
  chartData.value = data;
  visible.value = true;
  initChart();
};

const closeModal = () => {
  visible.value = false;
};

__expose({
  openModal,
});

const initChart = () => {
  if (!chartData.value.genData) {
    return;
  }
  var myChart = echarts.init(document.getElementById("detailChart"));
  myChart.setOption(JSON.parse(chartData.value.genData.replace(/'/g, '"')));
};

return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      onCancel: closeModal,
      footer: false,
      fullscreen: "",
      title: chartData.value.chartName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          size: "large",
          column: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "图表类型" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(chartData.value.chartType), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "图表目标" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(chartData.value.chartGoal), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "图表结果" }, {
              default: _withCtx(() => [
                (chartData.value.genResult)
                  ? (_openBlock(), _createBlock(_component_a_typography_title, {
                      key: 0,
                      heading: 6,
                      copyable: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(chartData.value.genResult), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "生成图表" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})